import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import './Header.css'

/*const MenuLink = ({stream, children, path}) => (
  <Link 
    key={2} 
    to={`/streams/${stream.id}/${path}`} 
    className="main-menu__item"
    activeClassName="main-menu__item--active"
  >
    { children }
  </Link>
)*/

const Header = ({location, searchSuggestions}) => {

  return (
    <header className="top-header">
      <div className="top-header__main hbox hbox--vcenter">
        <Link to="/" className="main-logo">VAIX <span>rightbet</span></Link>

        <div className="main-menu">
          <Link to="/players" className="main-menu__item">Players</Link>
        </div>
      </div>
      
    </header>
  )
}

export default connect( 
  (state, ownProps) => {
    return {
      location: state.routing.locationBeforeTransitions,
      searchSuggestions: state.ui.searchSuggestions.players,
    }    
  }, {}
)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js